(function() {
    "use strict";
    angular.module("cardFrontConsumer.areas.check-balance.check-balance-home", []);
}());